module.exports = __webpack_public_path__ + "assets/e999b6867fd3e9bc9de018bfef12da61.mp3";